export const HTTP_STATUS_UNAUTHORIZED = 401
export const HTTP_STATUS_FORBIDDEN = 403
export const HTTP_STATUS_UNPROCESSABLE_ENTITY = 422

export function getResponseStatus(error: unknown): number | undefined {
  const status = (error as { response?: { status?: unknown } })?.response?.status
  return typeof status === 'number' ? status : undefined
}

// Only follow same-app paths. A `redirect` query param is attacker-controlled,
// and router.push() would happily navigate to an absolute/external URL.
export function validateSafeRedirect(requested: unknown, fallback = '/'): string {
  return typeof requested === 'string' && /^\/(?!\/|\\)/.test(requested)
    ? requested
    : fallback
}
